import { render, staticRenderFns } from "./LogicalAxiomeHasValue.vue?vue&type=template&id=60828144"
import script from "./LogicalAxiomeHasValue.vue?vue&type=script&lang=js"
export * from "./LogicalAxiomeHasValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports